export const UsersTableColumns = (isArabic) => [
    { id: 'name', label: isArabic ? 'الاسم' : 'Name', align: 'start' },
    { id: 'email', label: isArabic ? 'البريد الإلكتروني' : 'Email', align: 'start' },
    { id: 'roles', label: isArabic ? 'الأدوار' : 'Roles', align: 'start' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];